import { useMemo } from "react";
import {
    buildOptionLabelMap,
    mergeRelationFlows,
    toFlowCard,
} from "../helpers/flowCards";
import useDataFlowOptions from "./useDataFlowOptions";
import useSoftwareDataFlowsV2 from "./useSoftwareDataFlowsV2";

const useDataFlowCards = ({ softwareId, wrapperAssetId, t } = {}) => {
    const optionsQuery = useDataFlowOptions({ t });
    const dataFlowsQuery = useSoftwareDataFlowsV2({ softwareId, t });

    const options = optionsQuery.data || {};

    const methodLabels = useMemo(
        () => buildOptionLabelMap(options.transfer_methods),
        [options.transfer_methods]
    );
    const typeLabels = useMemo(
        () => buildOptionLabelMap(options.data_types),
        [options.data_types]
    );
    const categoryLabels = useMemo(
        () => buildOptionLabelMap(options.data_categories),
        [options.data_categories]
    );
    const relationLabels = useMemo(
        () => buildOptionLabelMap(options.relations),
        [options.relations]
    );
    const endpointTypeLabels = useMemo(
        () => buildOptionLabelMap(options.endpoint_types),
        [options.endpoint_types]
    );

    const { incomingCards, outgoingCards } = useMemo(() => {
        const groups = dataFlowsQuery.data || {};
        const { incoming, outgoing } = mergeRelationFlows(
            groups.receives_from,
            groups.sends_to,
            groups.relations,
            wrapperAssetId
        );

        return {
            incomingCards: incoming.map((flow) =>
                toFlowCard(flow, "receives", wrapperAssetId)
            ),
            outgoingCards: outgoing.map((flow) =>
                toFlowCard(flow, "sends", wrapperAssetId)
            ),
        };
    }, [dataFlowsQuery.data, wrapperAssetId]);

    return {
        incomingCards,
        outgoingCards,
        methodLabels,
        typeLabels,
        categoryLabels,
        relationLabels,
        endpointTypeLabels,
        isLoading: dataFlowsQuery.isLoading,
    };
};

export default useDataFlowCards;
